<template>
  <div class="on-transaction-label" @click.stop="onClick">
    <slot name="label-text"></slot>
    <div class="what-to-do">מה כדאי לעשות?</div>
  </div>
</template>

<script>
export default {
  name: 'OnTransactionLabel',
  props: {
    onClick: { required: true },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.on-transaction-label {
  background-color: $riseup_danger_light_red;
  padding: 8px 14px 8px 12px;
  line-height: 18px;
}

.what-to-do {
  font-weight: bold;
  text-decoration: underline
}
</style>
